import {DataFetcher} from '@aboutyou/data-fetcher';
import {Head} from '@aboutyou/head-elements';
import React, {Fragment} from 'react';

import {Page} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/page.types';
import {TrackContentPageView} from '@aboutyou/tracking';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../../shared-deprecated/metaUtils';
import {useGetMetaData} from '../hooks/useGetMetaData';

export const HelpCenterMeta: React.FC = () => {
  return (
    <DataFetcher request={useGetMetaData()} Error={() => null} View={View} />
  );
};

const View: React.FC<{meta: Page}> = ({meta}) => {
  if (!isSeoData(meta)) {
    return null;
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <Fragment>
      <TrackContentPageView pageTitle={seoData.title} />
      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </Fragment>
  );
};
